import { useState, useEffect } from "react";
import { apiFetch } from "../../lib/config";

interface LogEntry { id: string; service_name: string; level: string; message: string; timestamp: string; }

const LEVELS = ["", "debug", "info", "warning", "error", "critical"];

export function LogsPage() {
  const [logs, setLogs] = useState<LogEntry[]>([]);
  const [service, setService] = useState(""); const [level, setLevel] = useState("");
  const [from, setFrom] = useState(""); const [to, setTo] = useState(""); const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  async function loadLogs() {
    setLoading(true);
    const params = new URLSearchParams();
    if (service) params.set("service", service); if (level) params.set("level", level);
    if (from) params.set("from", from); if (to) params.set("to", to); if (query) params.set("q", query);
    const r = await apiFetch(`/api/v1/telemetry/logs/?${params.toString()}`);
    if (r.ok) setLogs(await r.json()); setLoading(false);
  }

  useEffect(() => { loadLogs(); }, []);

  return (
    <div className="ac-page">
      <div className="ac-page-header">
        <div className="ac-page-header__left">
          <h1 className="ac-page-title">Log Explorer</h1>
          <p className="ac-page-subtitle">Search and filter structured application logs</p>
        </div>
      </div>
      <form className="ac-filter-bar" onSubmit={e => { e.preventDefault(); loadLogs(); }}>
        <input type="text" className="aptean-input" placeholder="Service name" value={service} onChange={e => setService(e.target.value)} aria-label="Service" style={{ minWidth: 160 }} />
        <select className="aptean-input" value={level} onChange={e => setLevel(e.target.value)} aria-label="Level">
          <option value="">All levels</option>
          {LEVELS.filter(Boolean).map(l => <option key={l} value={l}>{l.charAt(0).toUpperCase() + l.slice(1)}</option>)}
        </select>
        <input type="datetime-local" className="aptean-input" value={from} onChange={e => setFrom(e.target.value)} aria-label="From" title="From" />
        <input type="datetime-local" className="aptean-input" value={to} onChange={e => setTo(e.target.value)} aria-label="To" title="To" />
        <input type="text" className="aptean-input" placeholder="Search message..." value={query} onChange={e => setQuery(e.target.value)} style={{ minWidth: 200 }} />
        <button type="submit" className="aptean-btn aptean-btn--primary" disabled={loading}>Search</button>
      </form>
      <div className="ac-table-wrap">
        <table className="ac-table">
          <thead><tr><th style={{ width: "150px" }}>Timestamp</th><th style={{ width: "130px" }}>Service</th><th style={{ width: "80px" }}>Level</th><th>Message</th></tr></thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4}><div className="ac-empty"><div className="ac-empty__body">Loading logs...</div></div></td></tr>
            ) : logs.length === 0 ? (
              <tr><td colSpan={4}><div className="ac-empty"><div className="ac-empty__icon">&#8801;</div><div className="ac-empty__title">No log entries</div><div className="ac-empty__body">Adjust filters or ingest some log data.</div></div></td></tr>
            ) : logs.map(l => (
              <tr key={l.id}>
                <td className="ac-td--mono ac-td--muted" style={{ fontSize: "0.75rem" }}>{new Date(l.timestamp).toLocaleString()}</td>
                <td className="ac-td--muted">{l.service_name}</td>
                <td><span className={`ac-level-chip ac-level-${l.level}`}>{l.level}</span></td>
                <td style={{ fontFamily: "var(--aptean-font-mono)", fontSize: "0.8125rem" }}>{l.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
